/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gallery': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M233.4 11H70.3c-6.4 0-11.7 5.2-11.7 11.6v163.1c0 6.4 5.2 11.6 11.7 11.6h163.1c6.4 0 11.6-5.2 11.6-11.6V22.6c0-6.4-5.2-11.6-11.6-11.6zm-11.7 163.1H81.9V34.3h139.8v139.8z"/><path pid="1" d="M35.3 57.6H12v174.8c0 6.4 5.2 11.6 11.6 11.6h174.8v-23.3H35.3V57.6z"/><circle pid="2" cx="116.8" cy="69.3" r="23.3"/><path pid="3" d="M175.1 92.6l-30.2 45.2-16.4-22-34.9 46.6h116.5z"/>'
  }
})
